import { useEffect } from "react"
import { useSignUserOut } from "@/api/authQueries"
import { useNavigate } from "react-router-dom"
import { Loader } from "lucide-react"

export default function AuthLogout() {
    const navFunc = useNavigate()

    const { mutate: signOutUser } = useSignUserOut(navFunc)

    useEffect(() => {
        signOutUser()
    }, [signOutUser])

    return (
        <div className="flex h-svh w-svw items-center justify-center pb-20 pt-8">
            <div className="flex flex-col gap-4">
                <Loader size={64} className="animate-spin" />
                <h1 className="text-3xl font-bold">
                    Goodbye, hope to see you soon 😊
                </h1>
            </div>
        </div>
    )
}
